import { css } from 'lit';

export const iconStyles = css`
  :host {
    align-items: center;
    color: var(--badge-icon-color, var(--token-alias-content-icon-primary-default, light-dark(#3d3d42, #ffffff)));
    display: inline-flex;
    justify-content: center;
    line-height: 1;
    vertical-align: middle;
    cursor: inherit;
  }

  :host(:focus) {
    outline: 0;
    outline-offset: initial;
    color: var(--token-alias-content-icon-primary-active, light-dark(#0174bc, #7dcdff));
  }

  :host(:hover) {
    color: var(--token-alias-content-icon-primary-hover, light-dark(#009cde, #96cff0));
    cursor: pointer;
  }

  :host svg {
    display: inline-block;
    fill: currentColor;
    vertical-align: top;
  }

  :host([not-hoverable]) {
    color: var(--token-alias-content-icon-primary-default, light-dark(#3d3d42, #ffffff));
    cursor: inherit;
  }

  :host(:active) {
    color: var(--token-alias-content-icon-primary-active, light-dark(#0174bc, #7dcdff));
    cursor: pointer;
  }

  :host([disabled]),
  :host([disabled]:hover),
  :host([disabled]:active) {
    color: var(--token-alias-content-icon-primary-disabled, light-dark(#a3a3ab, #83838c));
    cursor: not-allowed;
    pointer-events: none;
  }
`;
